import {
    Button,
    Select,
} from 'antd';
import {
    DeleteOutlined,
} from '@ant-design/icons';
import { createAppSelectOptions } from '../../Common/utils';
import { useState } from 'react';

import * as Actions from 'flex/Actions';
import SelectScroll from './SelectScroll';
import useSelectScroll from './hooks/useSelectScroll';

const INITIAL_APP_LIST_STATE = {
    list: [],
    loading: false,
    pageTotal: 1,
    page: 1,
}

const AppSelectWithoutGroup = (props) => {
    const { name, form, organizationUuid, organizationAppLists, onRemove } = props;
    const organizationAppInfo = organizationAppLists[organizationUuid] || INITIAL_APP_LIST_STATE;
    // セレクトボックスの開閉時に連続したAPI呼び出しを防ぐためのフラグ。
    const [isInput, setIsInput] = useState(false);

    const { dataOptions, isScrolling, isSearching, hasMore, handleNextPage, handleSearch } = useSelectScroll({
        queryKey: 'title',
        query: [{ 'organization_uuid': organizationUuid }],
        data: organizationAppInfo,
        selector: (state) => state.appsListConnection,
        fetchAction: Actions.http.connection.apps.search,
    });

    const onChangeApp = (value) => {
        const fields = form.getFieldsValue();
        const { targetDetails } = fields;
        Object.assign(targetDetails[name], { app: value });
        form.setFieldsValue({ targetDetails });
    };

    return (
        <div className='search-target-detail'>
            <SelectScroll
                hasMore={hasMore}
                isSearching={isSearching}
                next={handleNextPage}
                options={dataOptions}
                search={handleSearch}
                renderItem={({
                    options,
                    searchValue,
                    loadMore,
                    notFoundContent,
                    handlePopupScroll,
                    handleSearch: onSearch,
                }) => {
                    return (
                        <Select
                            allowClear
                            filterOption={false}
                            notFoundContent={notFoundContent}
                            onChange={onChangeApp}
                            onPopupScroll={handlePopupScroll}
                            onSearch={!isScrolling ? onSearch : undefined}
                            onDropdownVisibleChange={(open) => {
                                if (!open && isInput) onSearch('');
                                // フラグをリセットする。
                                setIsInput(false);
                            }}
                            onInputKeyDown={(event) =>
                                event.ctrlKey ||
                                event.altKey ||
                                event.shiftKey
                                    ? setIsInput(false)
                                    : setIsInput(true)
                            }
                            placeholder='対象を選択してください'
                            searchValue={searchValue}
                            showSearch>
                            {createAppSelectOptions(options, searchValue)}

                            {loadMore}
                        </Select>
                    );
                }}
            />
            <Button
                className="mr-2"
                shape="circle"
                size="small"
                danger
                icon={<DeleteOutlined/>}
                onClick={onRemove}
            />
        </div>
    );
}

export default AppSelectWithoutGroup;
